import angular from "angular";

angular
    .module('app')
    .component('courseReview', {
        template: require('./course-review.html'),
        controller: ['$uibModal', '$http', '$sce', '$timeout', '$interval', 'Notifier','trans', 'Language','moment', controller],
        bindings: {
            course: '<',
            review: '<',
        }
    });

function controller($uibModal, $http, $sce, $timeout, $interval, Notifier,trans, Language,moment) {

    let $ctrl = this;

    $ctrl.text = null;
    $ctrl.rating = null;
    $ctrl.l = null;

    $ctrl.$onInit = function () {
        $ctrl.text = $ctrl.review ? $ctrl.review.text : null;
        $ctrl.rating = $ctrl.review ? $ctrl.review.rating : null;
        $ctrl.exist = $ctrl.review ? $ctrl.review.id: null ;

        $timeout(function () {
            $ctrl.lessons = [];
            $ctrl.course.chapters.forEach(function (chapter, chapterInd) {
                chapter.lessons.forEach(function (lesson, lessonInd) {
                    $ctrl.lessons.push(lesson);
                    lesson.pTitle = (chapterInd + 1) + '.' + (lessonInd + 1) + ' ' + lesson.title;
                });
            });
        });
    };

    $ctrl.submit = function () {
        $http.post(`/cabinet/courses/${$ctrl.course.id}/${$ctrl.exist ? 'edit-review' : 'send-review'}`, {
            text: $ctrl.text,
            rating: $ctrl.rating
        }).then(
            function (response) {

                window.Swal.fire({
                    icon: 'success',
                    title: trans('Thanks for review'),
                    showConfirmButton: false,
                    text: trans('Wait for metodist reply')
                });

                $ctrl.review = {
                    id: response.data.review_id,
                    text: $ctrl.text,
                    rating: $ctrl.rating,
                    created_at: moment(),
                };

                $ctrl.exist = true;

            },
            function (error) {
                if (error.status == 422) {
                    $ctrl.validationErrors = error.data.errors;
                    Notifier.error(trans('Error filling'), 2);
                } else {
                    Notifier.error(trans('An error occurred with the text: :error',error.data.message), 2);
                }
            });
    };

    $ctrl.toggleChapter = function (chapter) {
        chapter.open = !chapter.open;
    };

    $ctrl.goToLesson = function () {
        window.location = `/cabinet/courses/${$ctrl.course.id}/?lesson_id=${$ctrl.l.id}`;
    };

}
